import React, { useEffect, useState } from "react";
import { chatInit } from "@origin-digital/event-dispatcher";
import { AsyncMessengerIcon } from "./AsyncMessengerIcon";
import { showNativeMessenger } from "./chat.helper";

const CUSTOM_WIDGET_LAUNCHER_ID = "async-messenger-launcher";

export const AsyncMessenger = (): JSX.Element => {
  const [showAsyncChat, setShowAsyncChat] = useState<boolean>(false);

  useEffect(() => {
    chatInit({})?.then(({ success }) => {
      setShowAsyncChat(!!success);
    });
  }, []);

  return showAsyncChat ? (
    <AsyncMessengerIcon
      customLauncherSelector={CUSTOM_WIDGET_LAUNCHER_ID}
      onClick={(): void => showNativeMessenger()}
    />
  ) : (
    <></>
  );
};
